import { render, staticRenderFns } from "./ThumbnailZoom.vue?vue&type=template&id=f4547ba4"
import script from "./ThumbnailZoom.vue?vue&type=script&lang=js"
export * from "./ThumbnailZoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports